import React, { useState } from 'react';
import { AlertCircleIcon } from 'lucide-react';
interface PaymentMethodsProps {
  amount: number;
  title: string;
  description: string;
  buttonText: string;
  onPaymentComplete: (data: {
    method: string;
  }) => void;
}
export function PaymentMethods({
  amount,
  title,
  description,
  buttonText,
  onPaymentComplete
}: PaymentMethodsProps) {
  const [selectedMethod, setSelectedMethod] = useState<string | null>(null);
  const handlePaymentSubmit = () => {
    if (selectedMethod) {
      onPaymentComplete({
        method: selectedMethod
      });
    }
  };
  return <div className="animate-fadeIn" data-id="element-2338">
      <div className="text-center mb-6" data-id="element-2339">
        <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-2340">{title}</h3>
        <p className="text-slate-600" data-id="element-2341">{description}</p>
        <div className="mt-3 inline-block bg-slate-100 px-4 py-2 rounded-full" data-id="element-2342">
          <span className="font-bold text-slate-900" data-id="element-2343">{amount} دينار</span>
        </div>
      </div>
      <div className="space-y-4 mb-6" data-id="element-2344">
        <button onClick={() => setSelectedMethod('cliq')} className={`w-full p-4 border rounded-lg text-right flex items-center transition-all duration-200 ${selectedMethod === 'cliq' ? 'bg-green-50 border-green-300 ring-2 ring-green-100' : 'bg-white hover:bg-green-50 hover:border-green-200'}`} data-id="element-2345">
          <div className="w-12 h-12 ml-4 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-2346">
            <span className="text-2xl" data-id="element-2347">📱</span>
          </div>
          <div data-id="element-2348">
            <h4 className="font-medium text-slate-900 mb-1" data-id="element-2349">الدفع عبر CliQ</h4>
            <p className="text-sm text-slate-500" data-id="element-2350">
              طريقة سهلة وسريعة للدفع من خلال تطبيق البنك الخاص بك
            </p>
          </div>
        </button>
        <button onClick={() => setSelectedMethod('bank-transfer')} className={`w-full p-4 border rounded-lg text-right flex items-center transition-all duration-200 ${selectedMethod === 'bank-transfer' ? 'bg-blue-50 border-blue-300 ring-2 ring-blue-100' : 'bg-white hover:bg-blue-50 hover:border-blue-200'}`} data-id="element-2351">
          <div className="w-12 h-12 ml-4 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-2352">
            <span className="text-2xl" data-id="element-2353">🏦</span>
          </div>
          <div data-id="element-2354">
            <h4 className="font-medium text-slate-900 mb-1" data-id="element-2355">تحويل بنكي</h4>
            <p className="text-sm text-slate-500" data-id="element-2356">
              تحويل مباشر إلى الحساب البنكي للمشروع
            </p>
          </div>
        </button>
      </div>
      <div className="mt-6 p-4 bg-amber-50 rounded-lg border border-amber-200 mb-6" data-id="element-2357">
        <div className="flex items-start" data-id="element-2358">
          <AlertCircleIcon className="h-5 w-5 text-amber-500 mt-0.5 ml-2 flex-shrink-0" data-id="element-2359" />
          <p className="text-sm text-amber-700" data-id="element-2360">
            جميع التبرعات تستخدم لتطوير المحتوى وتحسين المشروع. سيتم تأكيد
            استلام التبرع خلال 24 ساعة عمل.
          </p>
        </div>
      </div>
      <button onClick={handlePaymentSubmit} disabled={!selectedMethod} className={`w-full py-3 px-4 rounded-md font-medium transition-colors duration-200 ${!selectedMethod ? 'bg-slate-300 text-slate-500 cursor-not-allowed' : 'bg-sky-600 hover:bg-sky-700 text-white'}`} data-id="element-2361">
        {buttonText}
      </button>
    </div>;
}